module.exports = __webpack_public_path__ + "static/media/logo-full(ru).6c3a7f86.svg";